import alerts from "./alerts.json";
import form from "./form.json";

const CancellationPenalityConfig = {
    alerts,
    form,
};

export default CancellationPenalityConfig;